<template>
    <div class="header">
        <section class="header__logo">
            <img class="image" src="@/assets/imgs/radio-memory-logo.png" alt="Logo">
            <div class="text">
                <h2 class="text__title">RM RadioBot</h2>
                <span class="text__subtitle">Visualizador panorâmico</span>
            </div>
        </section>
        <section class="header__toolbar">
            <div v-for="toolbar of toolbars" :key="toolbar.id" class="list">
                <headerToolbarCMP :id="toolbar.id" :buttons="toolbar.buttons"></headerToolbarCMP>
                <div v-if="toolbar.id !== gConsts.ui.toolbar.ids.OTHER" class="list__separator"></div>
            </div>
        </section>

        <section class="header__actions">
            <!-- <primaryButton :disabled="true" @click="printExam">
                <template #icon>
                    <PrintIconSvg />
                </template>
                Imprimir
            </primaryButton> -->
            <primaryButton :disabled="isSaving" @click="saveExam">
                <template #icon>
                    <template v-if="isSaving">
                        <LoadingSpinner :size="16" />
                    </template>
                    <template v-else>
                        <SaveIconSvg width="16" height="16" />
                    </template>
                </template>
                {{isSaving ? 'Salvando...' : 'Salvar'}}
            </primaryButton>
        </section>
    </div>

</template>

<script>
import { mapGetters } from 'vuex';
import { gConsts } from '@/globals/gConsts';
import headerToolbarCMP from './headerToolbar.vue';
import PrintIconSvg from '@/assets/icons/print.svg';
import primaryButton from '@/components/ui/button/primaryButton.vue';
import SaveIconSvg from '@/assets/icons/toolbar/save-image.svg';
import { exporter } from '@/mixins/exporter';
import LoadingSpinner from '@/components/ui/loading/loadingSpinner.vue';

export default {
    name: 'Header',
    components: {
        headerToolbarCMP,
        // PrintIconSvg,
        SaveIconSvg,
        primaryButton,
        LoadingSpinner
    },
    mixins: [exporter],
    data() {
        return {
            gConsts: gConsts
        }
    },
    computed: {
        ...mapGetters([
            'GET_colorTheme',
            'GET_appToolbars',
        ]),

        toolbars() {
            return Object.entries(this.GET_appToolbars).map(([id, toolbar]) => {
                return {
                    id,
                    buttons: toolbar
                }
            }).filter(toolbar => toolbar.buttons.length > 0);
        }
    },
    methods: {
    }
}
</script>

<style scoped>
.header {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    column-gap: var(--spacing-md);
    padding: var(--spacing-md) var(--spacing-xl);
    background-color: var(--background-white);
    border-bottom: 1px solid var(--border-primary);
}

.header__logo {
    display: flex;
    align-items: center;
    gap: 10px;
}

.header__logo>.image {
    width: 70px;
    object-fit: contain;
}

.header__logo>.text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-family: var(--font-family-primary);
}

.header__logo>.text>.text__title {
    font-size: var(--text-lg);
    font-weight: 700;
    line-height: 1;
    color: var(--color-primary);
    margin: 0;
}

.header__logo>.text>.text__subtitle {
    font-size: var(--text-xs);
    font-weight: 300;
    line-height: 1;
    color: var(--color-light-blue);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
    margin: 0;
}

.header__toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
}

.header__toolbar>.list {
    display: flex;
    align-items: center;
    gap: 10px;
}

.header__toolbar>.list>.list__separator {
    width: 1px;
    height: 20px;
    background: #dddddd;
    margin: 5px 0;
    align-self: center;
}

.header__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
}
</style>